<template>
	<v-alert
		color="cyan"
		border="left"
		elevation="2"
		colored-border
		icon="share"
	>
		<a :href="game.link">
			{{game.link}}
		</a>
	</v-alert>
</template>

<script>
	export default {
		name: "share-link",
		props: {game: Object},
		components: {},
		data() {
			return {
				model: true
			};
		}
	};
</script>

<style scoped>

</style>
